import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BusinessCard = ({ business }) => {
  const navigate = useNavigate();

  const handleViewProfile = () => {
    navigate('/business-profile', { state: { business } });
  };

  const handleWhatsAppContact = () => {
    const message = encodeURIComponent(`Hola ${business?.name}, vi tu negocio en BIZZNET y me interesa conocer más sobre tus descuentos.`);
    window.open(`https://wa.me/${business?.whatsapp}?text=${message}`, '_blank');
  };

  const handleSocialMedia = (platform) => {
    if (business?.socialMedia?.[platform]) {
      window.open(business?.socialMedia?.[platform], '_blank');
    }
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name={index < Math.floor(rating) ? 'Star' : 'Star'}
        size={14}
        color={index < Math.floor(rating) ? '#F59E0B' : '#E5E7EB'}
        className={index < Math.floor(rating) ? 'fill-current' : ''}
      />
    ));
  };

  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-card hover:shadow-modal transition-shadow duration-200">
      <div className="relative h-48 overflow-hidden bg-muted">
        <Image
          src={business?.logo}
          alt={business?.logoAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 right-3 bg-accent text-accent-foreground px-3 py-1.5 rounded-full font-bold text-sm shadow-md">
          {business?.discount}% OFF
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between mb-2">
          <h3 className="text-lg font-bold text-foreground line-clamp-1">
            {business?.name}
          </h3>
          <div className="flex items-center gap-1">
            {renderStars(business?.rating)}
          </div>
        </div>

        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
          <Icon name="Tag" size={14} />
          <span className="line-clamp-1">{business?.category}</span>
        </div>

        <div className="flex items-start gap-2 text-sm text-muted-foreground mb-3">
          <Icon name="MapPin" size={14} className="mt-0.5 flex-shrink-0" />
          <span className="line-clamp-2">{business?.address}</span>
        </div>

        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-4">
          <Icon name="Phone" size={14} />
          <span>{business?.phone}</span>
        </div>

        <div className="flex gap-2 mb-3">
          <Button
            variant="default"
            size="sm"
            onClick={handleWhatsAppContact}
            iconName="MessageCircle"
            iconPosition="left"
            fullWidth
          >
            WhatsApp
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={handleViewProfile}
            iconName="Eye"
            iconPosition="left"
            fullWidth
          >
            Ver Perfil
          </Button>
        </div>

        <div className="flex items-center justify-center gap-3 pt-3 border-t border-border">
          {business?.socialMedia?.facebook && (
            <button
              onClick={() => handleSocialMedia('facebook')}
              className="text-muted-foreground hover:text-primary transition-colors"
              aria-label="Facebook"
            >
              <Icon name="Facebook" size={20} />
            </button>
          )}
          {business?.socialMedia?.instagram && (
            <button
              onClick={() => handleSocialMedia('instagram')}
              className="text-muted-foreground hover:text-primary transition-colors"
              aria-label="Instagram"
            >
              <Icon name="Instagram" size={20} />
            </button>
          )}
          {business?.socialMedia?.twitter && (
            <button
              onClick={() => handleSocialMedia('twitter')}
              className="text-muted-foreground hover:text-primary transition-colors"
              aria-label="Twitter"
            >
              <Icon name="Twitter" size={20} />
            </button>
          )}
          <button
            onClick={handleViewProfile}
            className="text-muted-foreground hover:text-primary transition-colors"
            aria-label="Ver código QR"
          >
            <Icon name="QrCode" size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusinessCard;